import React from 'react';

import fetch from './fetch';

import utils from '../utils';

import { Modal, message, Tag } from 'antd';
import moment from 'moment';

const DataGrid = {
    selections: [],
    data: [],
    refresh: function () {

    }
}

const columnsArray = [
    { type: 'selection' },
    { key: '$index', label: '序号' , width: 70 },
    {
        key: 'majorName', width: 120,
        label: '所属部门'
    },
    {
        key: 'detailName', width: 100,
        label: '名称',
    },
    {
        key: 'fileVos', width: 120,
        label: '附件',
        render: (files) => {
            if(files && files.length > 0) {
                return (
                    <ol className="upper-alpha">
                        {
                            files.map((file) => (
                                <li><a href={window.base + 'zgcp/enter/file/download?id=' + file.id} target="_blank">{ file.fileName }</a></li>
                            ))
                        }
                    </ol>
                )
            }
            return "无";
        }
    },
    {
        key: 'bgTermName', width: 100,
        label: '开始学期'
    },
    {
        key: 'endTermName', width: 100,
        label: '结束学期',
    },
    {
        key: 'detailDesc', width: 120,
        label: '描述'
    },
    {
        key: 'createUserName', width: 70,
        label: '上传人'
    },
    { key: 'createDate', label: '创建日期', width: 120, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    { key: 'lastUpdateDate', label: '更新日期', width: 120, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" }
]

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号' , width: 70},
    {
        key: 'majorName', width: 120,
        label: '所属部门'
    },
    {
        key: 'detailName', width: 100,
        label: '名称',
    },
    {
        key: 'fileVos', width: 120,
        label: '附件',
        render: (files) => {
            if(files && files.length > 0) {
                return (
                    <ol className="upper-alpha">
                        {
                            files.map((file) => (
                                <li><a href={window.base + 'zgcp/enter/file/download?id=' + file.id} target="_blank">{ file.fileName }</a></li>
                            ))
                        }
                    </ol>
                )
            }
            return "无";
        }
    },
    {
        key: 'bgTermName', width: 100,
        label: '开始学期'
    },
    {
        key: 'endTermName', width: 100,
        label: '结束学期',
    },
    {
        key: 'detailDesc', width: 120,
        label: '描述'
    },
    {
        key: 'createUserName', width: 70,
        label: '上传人'
    },
    { key: 'createDate', label: '创建日期', width: 120, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    { key: 'lastUpdateDate', label: '更新日期', width: 120, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" }
])

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    var params = [];
    var newKeyword = {};

    for (var i in keywords) {
        if (i === 'pageSize') {
            params.push(`pageSize=${keywords[i]}`);
        } else if (i === 'pageNum') {
            params.push(`pageNum=${keywords[i]}`);
        } else if (i === 'sort') {
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    return fetch.post('major/query?' + params.join('&'), newKeyword)
        .then(response => {
            return {
                data: response.payload.data,
                meta: response.payload.meta,
                headers: utils.columns(columnsArray)
            };
        })
        .then(res => {
            const list = (Object.assign({
                headers: res.headers,
                result: (res.data.dataList || []).map(d => {
                    return Object.assign({}, d, {
                        height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
                    })
                }),
                selects: (res.data.dataList || []).map((d, i) => ({
                    value: d.id,
                    checked: false,
                    height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
                })),
                checked: false,
                meta: res.meta,
                total: res.data.total,
                pageIndex: res.data.pageNum,
                pageSize: res.data.pageSize,
                notify: (res.data.dataList || []).length ? '' : '暂无数据...'
            }))
            DataGrid.data = list.result;
            return list;
        }
    );
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('major/get/' + id, {})
        .then(response => {
            return response.payload.data;
        });
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getUserSelectData = () => {
    const id = DataGrid.selections[0]
    return DataGrid.data.find(d => d.id === id)
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('major/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}


/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

export default {
    querySearch,
    querySearchById,
    download: fetch.base + 'zgcp/enter/file/download?id=',
    headers,
    onSelect,
    setRefresh,
    getSelection,
    batchRemove,
    getUserSelectData
}
